import { PAGINEDETAIL } from 'utils/endpoint'
import { api } from 'utils'
import MetaSeo from 'components/atomic/MetaSeo'
import ContattiTemplate from 'react-components/templates/ContattiTemplate/ContattiTemplate'

api.defaults.xsrfCookieName = 'csrftoken'
api.defaults.xsrfHeaderName = 'X-CSRFTOKEN'

const Contatti = ({ pagina }) => {
  return (
    <>
      <MetaSeo seo={pagina.seo} />
      <ContattiTemplate />
    </>
  )
}

export const getStaticProps = async () => {
  const pageResponse = await api.get(PAGINEDETAIL, {
    params: {
      chiave: 'contatti',
    },
  })
  const pagina = await pageResponse.data
  const toolbarProps = { toolbarPage: pagina }

  return { props: { pagina, ...toolbarProps }, revalidate: 60 * 60 }
}

export default Contatti
